import React from "react";
import StarterKit from "@tiptap/starter-kit";
import { RichTextReadOnly } from "mui-tiptap";

interface RichTextContentProps {
  content: string;
}

export const RichTextContent: React.FC<RichTextContentProps> = ({
  content,
}) => {
  return (
    <RichTextReadOnly
      extensions={[StarterKit]}
      content={content}
      RichTextContentProps={{ fontSize: "12px" }}
      sx={({ palette }) => ({
        "& .ProseMirror": {
          color: palette.text.secondary,
        },
        "&.MuiTiptap-RichTextContent-root.MuiTiptap-RichTextContent-readonly .ProseMirror":
          {
            fontSize: "12px",
          },
      })}
    />
  );
};
